export default "/_next/static/bb444ea7f66009ea14d157958eaf1fbc.png";